import { render, staticRenderFns } from "./SeriesList.vue?vue&type=template&id=40a2bd0b&scoped=true&"
import script from "./SeriesList.vue?vue&type=script&lang=js&"
export * from "./SeriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a2bd0b",
  null
  
)

export default component.exports